/* Copyright (c) 2020-present CloudIO Inc */

import {
  ToolTip,
  ToolTipDefaultValue,
} from 'componentregistry/utils/commonProps';
import type { Property } from 'csstype';
import {
  CommonProps,
  defaultCommonProps,
} from '../../layout/Sidebar/panels/PropertiesView/CommonProperties';
import {
  BaseComponentItem,
  Border,
  DefaultExpressionValue,
  ExpressionValue,
  Margin,
  Padding,
} from '../../registry/Component.type';

export interface BoxItem extends BaseComponentItem {
  props: Box;
  type: 'Box';
}

type BoxComponent = 'span' | 'img' | 'div';

export interface Box extends CommonProps, ToolTip {
  alignContent?: Property.AlignContent;
  alignItems?: Property.AlignItems;
  alignSelf?: Property.AlignSelf;
  alt?: ExpressionValue;
  background?: ExpressionValue;
  backgroundImage?: string;
  bgcolor?: ExpressionValue;
  hoverBgcolor?: ExpressionValue;
  border?: Border;
  borderRadius?: Property.BorderRadius;
  boxHeight?: Property.Height;
  boxShadow?: Property.BoxShadow;
  boxWidth?: Property.Width;
  color?: ExpressionValue;
  hoverColor?: ExpressionValue;
  onHoverAnimation?: boolean;
  component?: BoxComponent;
  display?: Property.Display;
  flexDirection?: Property.FlexDirection;
  flexGrow?: Property.FlexGrow;
  flexShrink?: Property.FlexShrink;
  gap?: Property.Gap;
  flexWrap?: Property.FlexWrap;
  fontSize?: Property.FontSize;
  fontStyle?: Property.FontStyle;
  fontWeight?: Property.FontWeight | '';
  justifyContent?: Property.JustifyContent;
  margin?: Margin;
  maxHeight?: Property.MaxHeight;
  maxWidth?: Property.MaxWidth;
  minHeight?: Property.MinHeight;
  minWidth?: Property.MinWidth;
  overflow?: Property.Overflow;
  padding?: Padding;
  src?: ExpressionValue;
  showOnlyOnHoverItemIds?: string[];
  // textAlign: Property.TextAlign;
}

export const defaultValue: Required<Box> = {
  ...defaultCommonProps,
  alignContent: '',
  alignItems: 'center',
  alignSelf: '',
  alt: DefaultExpressionValue,
  background: DefaultExpressionValue,
  backgroundImage: '',
  bgcolor: DefaultExpressionValue,
  hoverBgcolor: DefaultExpressionValue,
  border: { all: { width: 0 } },
  borderRadius: '',
  boxHeight: '',
  boxShadow: '',
  boxWidth: '',
  color: DefaultExpressionValue,
  hoverColor: DefaultExpressionValue,
  onHoverAnimation: false,
  component: 'div',
  display: 'flex',
  flexDirection: 'row',
  flexGrow: Number.MIN_VALUE,
  flexShrink: Number.MIN_VALUE,
  gap: '',
  flexWrap: 'nowrap',
  fontSize: '',
  fontStyle: 'normal',
  fontWeight: '',
  justifyContent: 'center',
  margin: { all: 0 },
  maxHeight: '',
  maxWidth: '',
  minHeight: '',
  minWidth: '',
  overflow: 'unset',
  padding: { all: 0 },
  src: DefaultExpressionValue,
  showOnlyOnHoverItemIds: [],
  ...ToolTipDefaultValue,
  // textAlign: 'unset',
};
